// extracted by mini-css-extract-plugin
export default {"products":"LE-z","oosMessaging":"ME-z"};